/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var attributes$s = {
  count: 'data-cart-count',
  limit: 'data-limit'
};
var CartCount = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartCount, _HTMLElement);
  var _super = _createSuper(CartCount);
  function CartCount() {
    var _this;
    _classCallCheck(this, CartCount);
    _this = _super.call(this);
    _this.cartCount = parseInt(_this.getAttribute(attributes$s.count));
    _this.limit = _this.getAttribute(attributes$s.limit);
    _this.onCartChangeCallback = _this.onCartChange.bind(_assertThisInitialized(_this));
    _this.update();
    return _this;
  }
  _createClass(CartCount, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      document.addEventListener('theme:cart:added', this.onCartChangeCallback);
      document.addEventListener('cart:itemsUpdated', function (event) {
        _this2.cartCount = event.detail.itemsQuantity;
        _this2.update();
      });
      document.addEventListener('rebuy:cart.add', function (event) {
        var _event$detail$cart, _event$detail$cart$ca;
        _this2.cartCount = (_event$detail$cart = event.detail.cart) === null || _event$detail$cart === void 0 ? void 0 : (_event$detail$cart$ca = _event$detail$cart.cart) === null || _event$detail$cart$ca === void 0 ? void 0 : _event$detail$cart$ca.item_count;
        _this2.update();
      });
      document.addEventListener('rebuy:cart.change', function (event) {
        var _event$detail$cart2, _event$detail$cart2$c;
        _this2.cartCount = (_event$detail$cart2 = event.detail.cart) === null || _event$detail$cart2 === void 0 ? void 0 : (_event$detail$cart2$c = _event$detail$cart2.cart) === null || _event$detail$cart2$c === void 0 ? void 0 : _event$detail$cart2$c.item_count;
        _this2.update();
      });
      document.addEventListener('cart:update', function (event) {
        _this2.cartCount = event.detail.newCartCount;
        _this2.update();
      });
      window.upcartOnCartUpdated = function (e) {
        // Dispatch the 'cart:update' event with a sample newCartCount value
        var event = new CustomEvent('cart:update', {
          detail: {
            newCartCount: e.item_count
          }
        });
        document.dispatchEvent(event);
      };
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.onCartChangeCallback);
      document.removeEventListener('cart:itemsUpdated', this.onCartChangeCallback);
      document.removeEventListener('rebuy:cart.add', this.onCartChangeCallback);
      document.removeEventListener('rebuy:cart.change', this.onCartChangeCallback);
    }
  }, {
    key: "onCartChange",
    value: function onCartChange(event) {
      this.cartCount = cart.cartCount;
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      if (this.cartCount === null || this.cartCount === 0) {
        this.style.display = 'none';
      } else {
        this.style.display = '';
        this.setAttribute(attributes$s.count, this.cartCount);
        var countValue = this.cartCount;
        if (this.limit && this.cartCount >= this.limit) {
          countValue = '9+';
        }
        console.log(this.innerHTML);
        this.innerText = countValue.toString();
        console.log(this, this.innerHTML);
      }
    }
  }]);
  return CartCount;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
var ProductGridItemSiblings = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ProductGridItemSiblings, _HTMLElement2);
  var _super2 = _createSuper(ProductGridItemSiblings);
  function ProductGridItemSiblings() {
    _classCallCheck(this, ProductGridItemSiblings);
    return _super2.call(this);
  }
  _createClass(ProductGridItemSiblings, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.querySelectorAll(".selector-siblings-item").forEach(function (item) {
        item.addEventListener("click", function (event) {
          _this3.querySelectorAll(".product-grid-item").forEach(function (product_card) {
            product_card.classList.remove("current_item");
            if (product_card.getAttribute("data-product-id") === item.getAttribute("data-product-id")) {
              product_card.classList.add("current_item");
            }
          });
        });
      });
    }
  }]);
  return ProductGridItemSiblings;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-grid-item-siblings', ProductGridItemSiblings);
var AccordionsWrapper = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(AccordionsWrapper, _HTMLElement3);
  var _super3 = _createSuper(AccordionsWrapper);
  function AccordionsWrapper() {
    var _this4;
    _classCallCheck(this, AccordionsWrapper);
    _this4 = _super3.call(this);
    _this4.limit = _this4.getAttribute("data-limit");
    _this4.textBefore = _this4.getAttribute("data-before-text");
    _this4.textAfter = _this4.getAttribute("data-after-text");
    return _this4;
  }
  _createClass(AccordionsWrapper, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this5 = this,
        _this$querySelector;
      this.querySelectorAll(".accordion__item").forEach(function (item, index) {
        if (index < _this5.limit) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
      (_this$querySelector = this.querySelector(".accordion-show-more")) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.addEventListener("click", function (event) {
        var isExpanded = event.target.getAttribute('aria-expanded') === 'true';
        event.target.setAttribute('aria-expanded', !isExpanded);
        _this5.querySelectorAll(".accordion__item").forEach(function (item, index) {
          if (isExpanded) {
            if (index >= _this5.limit) {
              item.style.display = "none";
            }
          } else {
            item.style.display = "block";
          }
        });

        // Update the text based on the expanded state
        event.target.innerText = isExpanded ? _this5.textBefore : _this5.textAfter;
      });
    }
  }]);
  return AccordionsWrapper;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('accordions-wrapper', AccordionsWrapper);
var VideoJsComponent = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(VideoJsComponent, _HTMLElement4);
  var _super4 = _createSuper(VideoJsComponent);
  function VideoJsComponent() {
    _classCallCheck(this, VideoJsComponent);
    return _super4.call(this);
  }
  _createClass(VideoJsComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Get references to the video element and play/pause button
      this.video = this.querySelector('.video-player');
      this.playPauseButton = this.querySelector('.playPauseBtn');

      // Initialize Video.js on the video element without controls
      this.player = videojs(this.video, {
        controls: false
      });

      // Add event listener to the button to toggle play/pause
      this.playPauseButton.addEventListener('click', this.togglePlayPause.bind(this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Clean up: dispose of the Video.js player
      if (this.player) {
        this.player.dispose();
      }
    }
  }, {
    key: "togglePlayPause",
    value: function togglePlayPause() {
      // Check if the video is paused and toggle play/pause
      if (this.player.paused()) {
        this.player.play();
      } else {
        this.player.pause();
      }
    }
  }]);
  return VideoJsComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("video-js-component", VideoJsComponent);
var VideoPlayer = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(VideoPlayer, _HTMLElement5);
  var _super5 = _createSuper(VideoPlayer);
  function VideoPlayer() {
    _classCallCheck(this, VideoPlayer);
    return _super5.call(this);
  }
  _createClass(VideoPlayer, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this6 = this;
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.video-play-button button');
      this.muteButton = this.querySelector('.mute-button');
      this.unmuteButton = this.querySelector('.unmute-button');
      this.addEventListener('click', function (event) {
        if (!(event.target instanceof SVGElement) && !event.target.closest('.mute-button') && !event.target.closest('.unmute-button')) {
          _this6.togglePlay.bind(_this6)(event);
        } else if (event.target.closest('.action-button')) {
          _this6.togglePlay.bind(_this6)(event);
        }
      });
      this.muteButton.addEventListener('click', this.toggleMute.bind(this));
      this.unmuteButton.addEventListener('click', this.toggleMute.bind(this));
    }
  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.video.play();
        this.playButton.style.display = 'none';
      } else {
        this.video.pause();
        this.playButton.style.display = '';
        this.muteButton.style.display = 'none';
        this.unmuteButton.style.display = 'none';
      }
      if (this.video.muted && !this.video.paused) {
        this.muteButton.style.display = 'initial';
        this.unmuteButton.style.display = 'none';
      } else if (!this.video.paused) {
        this.muteButton.style.display = 'none';
        this.unmuteButton.style.display = 'initial';
      }
    }
  }, {
    key: "toggleMute",
    value: function toggleMute(e) {
      e.preventDefault();
      if (this.video.muted) {
        this.video.muted = false;
        this.muteButton.style.display = 'none';
        this.unmuteButton.style.display = 'initial';
      } else {
        this.video.muted = true;
        this.muteButton.style.display = 'initial';
        this.unmuteButton.style.display = 'none';
      }
    }
  }]);
  return VideoPlayer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('video-player', VideoPlayer);
var KlaviyoFormComponent = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(KlaviyoFormComponent, _HTMLElement6);
  var _super6 = _createSuper(KlaviyoFormComponent);
  function KlaviyoFormComponent() {
    _classCallCheck(this, KlaviyoFormComponent);
    return _super6.call(this);
  }
  _createClass(KlaviyoFormComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.form = this.querySelector('.form-klaviyo-newsletter');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this7 = this;
      event.preventDefault();
      // Add any additional logic or validation here

      var emailInput = this.form.querySelector('input[name="contact[email]"]').value;
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=RNBfvW';
      var data = {
        data: {
          type: "subscription",
          attributes: {
            list_id: "W3NuRf",
            email: emailInput
          }
        }
      };
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Revision': '2023-06-15'
        },
        body: JSON.stringify(data)
      }).then(function (data) {
        if (data.ok) {
          _this7.querySelector('.form_on_success').style.display = "block";
          _this7.querySelector('.fieldset-with-submit').style.display = "none";
        } else {
          _this7.querySelector('.form_on_danger').style.display = "block";
          var submitButton = _this7.form.querySelector('button[type="submit"]');
        }
      })["catch"](function (errors) {
        _this7.querySelector('form-klaviyo-newsletter .form_on_danger').style.display = "block";
        var submitButton = _this7.form.querySelector('button[type="submit"]');
        submitButton.setAttribute('aria-busy', 'false');
      });
    }
  }]);
  return KlaviyoFormComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('form-klaviyo-newsletter', KlaviyoFormComponent);
var BlogPosts = /*#__PURE__*/function (_HTMLElement7) {
  _inherits(BlogPosts, _HTMLElement7);
  var _super7 = _createSuper(BlogPosts);
  function BlogPosts() {
    var _this8;
    _classCallCheck(this, BlogPosts);
    _this8 = _super7.call(this);
    _this8.posts = [];
    return _this8;
  }
  _createClass(BlogPosts, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.loadPosts();
      this.setupSearch();
    }
  }, {
    key: "loadPosts",
    value: function loadPosts() {
      var _this9 = this;
      this.querySelectorAll('.blog__post-item').forEach(function (item) {
        var post = {
          title: item.getAttribute('data-blog-title'),
          url: item.getAttribute('data-blog-url'),
          content: item.getAttribute('data-blog-content')
        };
        _this9.posts.push(post);
        item.classList.add('displayed');
      });
    }
  }, {
    key: "setupSearch",
    value: function setupSearch() {
      var _this10 = this;
      var searchInput = document.querySelector('.blog__search-form .blog__search-input');
      searchInput === null || searchInput === void 0 ? void 0 : searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });
      searchInput === null || searchInput === void 0 ? void 0 : searchInput.addEventListener('input', function (event) {
        var query = event.target.value.toLowerCase();
        _this10.displayPosts(query);
      });
    }
  }, {
    key: "displayPosts",
    value: function displayPosts(query) {
      this.querySelectorAll('.blog__post-item').forEach(function (item) {
        var title = item.getAttribute('data-blog-title').toLowerCase();
        var content = item.getAttribute('data-blog-content').toLowerCase();
        if (title.includes(query) || content.includes(query)) {
          item.classList.add('displayed');
        } else {
          item.classList.remove('displayed');
        }
      });
    }
  }]);
  return BlogPosts;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('blog-posts', BlogPosts);
var PromoVariantsItems = /*#__PURE__*/function (_HTMLElement8) {
  _inherits(PromoVariantsItems, _HTMLElement8);
  var _super8 = _createSuper(PromoVariantsItems);
  function PromoVariantsItems() {
    var _this11;
    _classCallCheck(this, PromoVariantsItems);
    _this11 = _super8.call(this);
    _this11.promoBundleContainers = _this11.querySelectorAll('.promo-bundle-outer-container[data-product-id]');
    _this11.currentId = _this11.getAttribute('data-current-id');
    return _this11;
  }
  _createClass(PromoVariantsItems, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this12 = this;
      document.addEventListener('theme:variant:change', function (event) {
        _this12.currentId = "" + event.detail.variant.id;
        _this12.render();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this13 = this;
      this.promoBundleContainers.forEach(function (container) {
        if (container.getAttribute('data-product-id') === _this13.currentId) {
          container.style.display = 'block';
        } else {
          container.style.display = 'none';
        }
      });
    }
  }]);
  return PromoVariantsItems;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('promo-variants-items', PromoVariantsItems);
var SiblingsTabs = /*#__PURE__*/function (_HTMLElement9) {
  _inherits(SiblingsTabs, _HTMLElement9);
  var _super9 = _createSuper(SiblingsTabs);
  function SiblingsTabs() {
    var _this14;
    _classCallCheck(this, SiblingsTabs);
    _this14 = _super9.call(this);
    _this14.promoBundleContainers = _this14.querySelectorAll('.product__tabs-container[data-product-id]');
    _this14.currentId = _this14.getAttribute('data-current-id');
    return _this14;
  }
  _createClass(SiblingsTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this15 = this;
      document.addEventListener('theme:variant:change', function (event) {
        _this15.currentId = "" + event.detail.variant.id;
        _this15.render();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this16 = this;
      this.promoBundleContainers.forEach(function (container) {
        if (container.getAttribute('data-product-id') === _this16.currentId) {
          container.style.display = 'flex';
        } else {
          container.style.display = 'none';
        }
      });
    }
  }]);
  return SiblingsTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-tabs-selector', SiblingsTabs);

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;